import React from "react";
import NotificationsContainer from "../../modules/Notifications/containers/NotificationsContainer/NotificationsContainer";

const Notifications = () => {
  return <NotificationsContainer />;
};

export default Notifications;
